"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 *
 * As we are debouncing a lot of search values in our apps, we can use this in one line,
 * instead of debouncing in a useEffect all and over again.
 * @param initialValue Equivalent to the initial state value of useState.
 * @param delay Delay of the debounced state change in milliseconds.
 * @returns [state, setState,debouncedState]
 */
function useStateDebounced(initialValue, delay) {
    if (delay === void 0) { delay = 600; }
    var _a = react_1.useState(initialValue), value = _a[0], setValue = _a[1];
    var _b = react_1.useState(initialValue), debouncedValue = _b[0], setDebouncedValue = _b[1];
    react_1.useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay]);
    var setValueWithForce = react_1.useCallback(function (value, force) {
        setValue(value);
        if (force) {
            setDebouncedValue(value);
        }
    }, [setValue, setDebouncedValue]);
    return [value, setValueWithForce, debouncedValue];
}
exports.default = useStateDebounced;
//# sourceMappingURL=useStateDebounced.js.map